export default function AppSection() {
  return (
    <section id="app" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="bg-background-50 border border-background-200/60 rounded-xl p-8 md:p-12 flex flex-col md:flex-row items-center gap-8">
          <div className="flex-shrink-0">
            <div className="w-24 h-24 md:w-32 md:h-32 rounded-2xl bg-primary-500/10 flex items-center justify-center border border-primary-500/20">
              <span className="w-14 h-14 md:w-18 md:h-18 flex items-center justify-center">
                <i className="ri-smartphone-line text-primary-500 text-4xl md:text-5xl"></i>
              </span>
            </div>
          </div>

          <div className="flex-1 text-center md:text-left">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
              随时随地观影
            </h2>
            <p className="text-sm md:text-base text-foreground-500 leading-relaxed mb-6">
              天天影院全面适配手机、平板、电脑等所有设备。无需下载APP，打开浏览器就能畅享最新电影大全、
              动作片在线、喜剧片免费看及科幻片高清播放。地铁上、午休时、被窝里，随时随地看大片。
            </p>
            <div className="flex flex-wrap items-center justify-center md:justify-start gap-4">
              <span className="inline-flex items-center gap-1.5 px-4 py-2 bg-background-100 border border-background-200/60 rounded-full text-xs text-foreground-600 whitespace-nowrap">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-computer-line text-primary-500"></i>
                </span>
                电脑端适配
              </span>
              <span className="inline-flex items-center gap-1.5 px-4 py-2 bg-background-100 border border-background-200/60 rounded-full text-xs text-foreground-600 whitespace-nowrap">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-tablet-line text-primary-500"></i>
                </span>
                平板端适配
              </span>
              <span className="inline-flex items-center gap-1.5 px-4 py-2 bg-background-100 border border-background-200/60 rounded-full text-xs text-foreground-600 whitespace-nowrap">
                <span className="w-4 h-4 flex items-center justify-center">
                  <i className="ri-smartphone-line text-primary-500"></i>
                </span>
                手机端适配
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}